import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {
    private appTitle = {
        register: '',
        registerEndCustomer: '',
        companyContacts: '',
    };

    private _appTitle$ = new BehaviorSubject<string>('');

    constructor(
        private translateService: TranslateService,
        private title: Title,
    ) {}

    setAppTitle(titleKey: string): void {
        setTimeout(() => {
            this.translateService
                .get(['APP.REGISTER.TITLE', 'APP.REGISTER-END-CUSTOMER.TITLE', 'APP.COMPANY_CONTACTS.TITLE'])
                .subscribe((translations) => {
                    this.appTitle = {
                        register: translations['APP.REGISTER.TITLE'],
                        registerEndCustomer: translations['APP.REGISTER-END-CUSTOMER.TITLE'],
                        companyContacts: translations['APP.COMPANY_CONTACTS.TITLE'],
                    };
                    this._appTitle$.next(this.appTitle[titleKey]);
                    this.title.setTitle(this.appTitle[titleKey]);
                });
        });
    }

    getBrowserCountry(): string {
        return navigator.language.split('-').pop().toUpperCase();
    }
}
